import React from 'react';

import { isNil, reduce } from 'lodash';

import {
  Log,
  LogText,
  LogLink,
  LogChanges,
  LogChangedValue,
} from '@gogame/components';

import { STATUS_ERROR } from 'scenes/SmartRules/constants';

import { getColor } from './ActionsLog';

const ACTION_TYPE_ERROR = 'Error';
const ACTION_TYPE_UPDATE = 'Update';
export default ({ log, key, onClickEntities, numberFormatter }) => {
  let result = null;
  const isError =
    log.type === ACTION_TYPE_ERROR || log.ruleStatus === STATUS_ERROR;

  if (isError) {
    result = log.data?.errors.map(({ message }) => message);
  }

  if (log.type === ACTION_TYPE_UPDATE) {
    const allChanges = reduce(
      log.data,
      (all, value, section) => {
        return [...all, ...value.map((v) => ({ ...v, section }))];
      },
      []
    );

    result = (
      <>
        {allChanges.map((change) => {
          const addedCount = change.added?.length || 0;
          const changedCount = change.changed?.length || 0;
          const deletedCount = change.deleted?.length || 0;

          const multiChanges =
            +!!addedCount + !!changedCount + !!deletedCount > 1;

          if (multiChanges) {
            return (
              <LogChanges type={'change'} label={change.field}>
                {change.added?.map((added, i) => (
                  <LogChangedValue value={added.name} key={`add-${i}`} />
                ))}
                {change.changed?.map((changed, i) => (
                  <LogChangedValue
                    value={changed.oldState?.name}
                    newValue={changed.updatedState?.name}
                    key={`change-${i}`}
                  />
                ))}
                {change.deleted?.map((deleted, i) => (
                  <LogChangedValue value={deleted.name} key={`deleted-${i}`} />
                ))}
              </LogChanges>
            );
          }

          return (
            <>
              {addedCount ? (
                <LogChanges type={'add'} label={change.field}>
                  {change.added.map((added, i) => (
                    <LogChangedValue value={added.name} key={`add-${i}`} />
                  ))}
                </LogChanges>
              ) : null}
              {changedCount ? (
                <LogChanges type={'change'} label={change.field}>
                  {change.changed?.map((changed, i) => (
                    <LogChangedValue
                      key={`change-${i}`}
                      value={changed.oldState?.name}
                      newValue={changed.updatedState?.name}
                    />
                  ))}
                </LogChanges>
              ) : null}

              {deletedCount ? (
                <LogChanges type={'remove'} label={change.field}>
                  {change.deleted?.map((deleted, i) => (
                    <LogChangedValue
                      value={deleted.name}
                      key={`deleted-${i}`}
                    />
                  ))}
                </LogChanges>
              ) : null}
            </>
          );
        })}
      </>
    );
  }

  if (!isNil(log.affectedEntitiesCount)) {
    result = (
      <LogLink onClick={() => onClickEntities(log)}>
        {`${numberFormatter(log.affectedEntitiesCount)} matches found`}
      </LogLink>
    );
  }

  return (
    <Log key={key} color={getColor(log.ruleStatus)}>
      <LogText
        status={log.ruleStatus}
        date={log.dateAdded}
        user={log.changedBy}
        action={log.type}
        description={log.message}
      >
        {result}
      </LogText>
    </Log>
  );
};
